import {API_VERSION} from '@/utils/constants/commonConstants'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const BULK_MODIFIERS_CONFIG = {
  BULK_MODIFIERS: queryParams => ({
    endPoint: 'bulk-point-modifier/list?' + queryParams,
    // mockData: BulkModifiersList,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
  }),
  REVIEW_BULK_MODIFIERS: {
    endPoint: 'bulk-point-modifier',
    method: HTTP_METHODS.POST,
  },
  VALIDATE_BULK_MODIFIER_NAME: {
    endPoint: 'bulk-point-modifiers/validate-name',
    method: HTTP_METHODS.GET,
    appendQueryParams: true,
  },
  BULK_MODIFIERS_CSV_DOWNLOAD: queryParams => ({
  endPoint: `bulk-point-modifier/download${queryParams ? `?${queryParams}` : ''}`,
  method: HTTP_METHODS.POST,
}),
  BULK_MODIFIER_DETAIL: (id, page, pageSize, type) => ({
    endPoint: `bulk-point-modifier/list?${type}=${id}&page=${page}&pageSize=${pageSize}`,
    method: HTTP_METHODS.POST,
  }),
  BULK_MODIFIERS_DRAFT: {
    endPoint: 'bulk-point-modifiers/draft',
    method: HTTP_METHODS.POST,
  },
  BULK_MODIFIERS_DRAFT_UPDATE: {
    endPoint: 'bulk-point-modifiers/draft',
    method: HTTP_METHODS.PUT,
  },
}
